import {
  Title as MantineTitle,
  type TitleProps as MantineTitleProps,
} from "@mantine/core";
import type { CoreComponentProps } from "../../types";
import { useShouldRender } from "../../../hooks/useShouldRender";

export type TitleProps = CoreComponentProps<MantineTitleProps, 'div'>;

export function Title({ testId, view = "all", ...rest }: TitleProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <MantineTitle data-testid={testId} {...rest} />;
}
